/**
 * Careers page dropdown / list toggle
 * View vacancies based on country
 */
'use strict';

import Mustache from 'mustache';

declare global {
  interface Window {
    vacanciesConfig: {
      vacanciesCountry: string;
      vacancies: any[];
      vacanciesTemplate: string;
    }
  }
}

interface Careers {
  select: HTMLSelectElement | null;
  container: HTMLElement | null;
  vacancies: any[];
  itemTemplate: string;
  vacanciesCountry: string;
  setModelLang(lang: string): void;
  filterList(): any[];
  setList(): void;
  addEvents(): void;
  init(element: HTMLElement): void;
}

const careers: Careers = {
  select: null,
  container: null,
  vacancies: [],
  itemTemplate: '',
  vacanciesCountry: '',

  setModelLang: function (lang) {
    this.vacanciesCountry = lang;
  },

  /**
   * Get vacancies with the right country
   * @return {Array}
   */
  filterList: function () {
    const self = this;

    var list = self.vacanciesCountry === 'all' ? self.vacancies : self.vacancies.filter(function (c) {
      return c.country === self.vacanciesCountry;
    });

    return list;
  },

  /**
   * Re-render the list
   */
  setList: function () {
    const self = this;
    var list = self.filterList();

    let resultsHtml = '';


    list.forEach((item) => {
      resultsHtml = resultsHtml + Mustache.render(this.itemTemplate, item);
    });

    this.container!.innerHTML = resultsHtml;
  },


  /**
   * Add a click event listener to the select element
   * On change re-render the list
   */
  addEvents: function () {
    const self = this;
    self.select?.addEventListener('change', function (event) {
      self.setModelLang((event?.target as HTMLOptionElement).value);
      self.setList();
    });
  },

  init: function (element: HTMLElement) {
    const self = this;

    console.log(self)
    self.select = element.querySelector('.careers-country-select') || null;
    self.container = element.querySelector('.careers-container') || null;
    self.vacanciesCountry = window.vacanciesConfig.vacanciesCountry || '';
    self.vacancies = window.vacanciesConfig.vacancies || [];
    self.itemTemplate = window.vacanciesConfig.vacanciesTemplate || '';


    if (self.select && self.container && self.vacanciesCountry && self.vacancies) {
      // Select element and required window variables found > continue initializing...
      console.log('careers.init()');
      self.addEvents();
    }

  } // init
};

export default careers;
